<template lang="html">
  <div class="col-lg-9 col-page-content page-messages">
    <div class="row">

      <div class="col-12">
        <div class="box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Mensajes</h4>
              <hr />
            </div>

            <div class="col-12 messages-container">
              <div class="row">

                <!-- Opened Message -->
                <div class="col-lg-12 col-messages">
                  <!-- <div class="box-selected-user-name">
                    Stefany Bosch
                  </div> -->
                   <div class="box-selected-user-msgs" v-if="$root.user.messages.length == 0">
                      <p>No has recibido ningun mensaje</p>
                  </div>
                  <div class="box-selected-user-msgs" style="height:auto !important;" v-else>
                    <div class="content" id="responses-wr">

                      <div class="box-response" v-for="(msg, respInx) in $root.user.messages" :key="'respInx-'+respInx">
                        <div class="row-resp">
                          <div class="col-12 col-date">
                            <h6>Fecha de mensaje: {{ msg.creado }}</h6>
                          </div>

                          <div class="col col-photo">
                            <div class="placed-backg photo" v-bind:style="{ backgroundImage: 'url('+msg.img+')' }"></div>
                          </div>

                          <div class="col col-response">
                            <h6><span class="name">{{ msg.nombre }} </span><!--  - <span class="date">12:30 pm</span> --></h6>

                            <div class="box-resp" v-html="msg.msg"></div>
                           
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

               
                </div>
                <!--  -->

              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      formSearch: {
        keywords: null,
      },

      formResp: {
        msg: null
      },

      ejemploArrayMsg: [
     
      ],
    }
  },

  methods: {
    onSubmitSearch(event) {
      event.preventDefault();
    },

    onSubmitResp(event) {
      event.preventDefault();

      // Detectar y agregar <br /> a los saltos de linea
      var resp = this.formResp.msg.replace(/\n\r?/g, '<br />');

      // Scroll hasta abajo del contenedor de mensajes
      var element = document.getElementById("responses-wr");
      element.scrollTop = element.scrollHeight;


      // AQUI X codigo para guardar en la BD con solo enters como html


      // Agregar el mensaje al inicio del array para que se muestre en el front
      this.ejemploArrayMsg.unshift({ img: 'public/images/pages/jobs/logo-1.png', name: 'Insumos Quirúrgicos', date: 'Marzo 7', msg: resp })
      this.formResp.msg = null;
    }
  },
}
</script>
